// Note: these are all stripe ids, not plan ids.

export const GS_SALEOR_MONTHLY_AFFILIATE_ID = 'GS00017'
export const GS_SALEOR_ANNUAL_AFFILIATE_ID = 'GS00018'
export const GS_AFFILIATE_ID = 'GS00001'
const STREAM_VA_ID = 'SV00004'
const STREAM_VA_BASIC_ID = 'SV00005'
const STREAM_VA_PRO_ID = 'SV00006'
const STREAM_VA_REL_PRO = 'price_1IIcmFASHJWgnbKEDbjhVrd8'
export const CARDADAY_STRIPE_ID = '14547'
export const UNLIMITED_STRIPE_ID = '15005'
export const UNLIMITED_STRIPE_ID_PLUS_GIFT = '15395'

export const STREAM_VA_SKUS = [
  STREAM_VA_ID,
  STREAM_VA_BASIC_ID,
  STREAM_VA_PRO_ID,
  STREAM_VA_REL_PRO,
]

export const SENDOGO_RP_STRIPE_ID = '14528'

export const ELITE_PLUS_STRIPE_ID = '14234'
export const CARD_PACKAGE_100 = '15053'
export const CARD_PACKAGE_250 = '15054'
export const CARD_PACKAGE_500 = '15027'
export const CARD_PACKAGE_1000 = '15028'
export const CARD_PACKAGE_2000 = '15029'
export const LEGACY_980_1 = '11103'
export const LEGACY_980_2 = '11124'
export const LEGACY_39 = '11121'
export const LEGACY_31 = '11095'

export const ACT_ADDON_STRIPE_ID = '15658'

// Note: these are actual plan ids
// TODO: move logic of whether plan is current or not to the backend or a CMS.

export const currentlySoldPlans = ['184', '189', '190', '191']
